import { ChevronLeft } from "lucide-react";
import { cva, VariantProps } from "class-variance-authority";
import { cn } from "@/src/lib/utils";
import { withMarginTw, WithMarginProp } from "@/src/styles/withMargin";
import { useHistory } from "react-router-dom";

const backButtonVariants = cva(
  "text-concrete-400 flex-shrink-0 inline-flex items-center justify-center rounded-md transition-colors bg-concrete-50 hover:bg-concrete-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      size: {
        xs: "h-6 w-6 p-1",
        sm: "h-8 w-8 p-1.5",
        default: "h-10 w-10 p-2",
        lg: "h-12 w-12 p-2.5",
        icon: "h-10 w-10 p-2",
      },
    },
    defaultVariants: {
      size: "default",
    },
  },
);

export interface BackButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof backButtonVariants>,
    WithMarginProp {
  to?: string;
}

export function BackButton({
  className,
  size,
  margin,
  to,
  ...props
}: BackButtonProps) {
  const history = useHistory();
  return (
    <button
      onClick={() => {
        if (to) {
          history.push(to);
        } else {
          history.goBack();
        }
      }}
      className={cn(
        backButtonVariants({ size }),
        withMarginTw({ margin }),
        className,
      )}
      {...props}
    >
      <ChevronLeft className="h-full w-full" />
    </button>
  );
}
